import { render, staticRenderFns } from "./LoadingSkeleton.vue?vue&type=template&id=a56ced8c&"
import script from "./LoadingSkeleton.vue?vue&type=script&lang=js&"
export * from "./LoadingSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports